export default "/images/channelAffinity.svg?92ac8dbbe4e1d15ac24f3a29cb30e88c";